'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _DependencyConstraint = require('./DependencyConstraint');

var _DependencyConstraint2 = _interopRequireDefault(_DependencyConstraint);

var _ResolveState = require('./ResolveState');

var _ResolveState2 = _interopRequireDefault(_ResolveState);

var _PluginConfiguration = require('../PluginConfiguration');

var _PluginConfiguration2 = _interopRequireDefault(_PluginConfiguration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 插件解析元数据
 * 
 * @class PluginMetadata
 */
var PluginMetadata = function () {

    /**
     * 创建一个元数据
     * 
     * @param {PluginConfiguration} pluginConfiguration 插件配置
     * @ignore
     * @memberof PluginMetadata
     */
    function PluginMetadata(pluginConfiguration) {
        (0, _classCallCheck3.default)(this, PluginMetadata);

        this.id = pluginConfiguration.id;
        this.version = pluginConfiguration.version;
        this.dependencyConstraints = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = (0, _getIterator3.default)(pluginConfiguration.dependencies), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var dependency = _step.value;

                this.dependencyConstraints.push(new _DependencyConstraint2.default(dependency.id, dependency.version));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        if (this.dependencyConstraints.length === 0) {
            this.state = _ResolveState2.default.RESOLVESUCCESS;
        } else {
            this.state = _ResolveState2.default.RESOLVABLE;
        }

        this.markResolvable = this.markResolvable.bind(this);
        this.markFailed = this.markFailed.bind(this);
        this.markSuccess = this.markSuccess.bind(this);
        // 依赖链，最后一个节点为依赖的根，启动时，从最后开始
        /**
         * @type {PluginMetadata[]}
         */
        this.dependencies = [];
    }

    /**
     * 标记为可以解析，将所有依赖关系也递归为可解析。注意：如果依赖为空，则直接成功
     * 
     * @memberof PluginMetadata
     */


    (0, _createClass3.default)(PluginMetadata, [{
        key: 'markResolvable',
        value: function markResolvable() {
            if (this.dependencyConstraints.length === 0) {
                this.markSuccess();
                return;
            }

            this.state = _ResolveState2.default.RESOLVABLE;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)(this.dependencyConstraints), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var dependencyConstraint = _step2.value;

                    dependencyConstraint.markResolvable();
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            this.dependencies = [];
        }

        /**
         * 标记为解析失败，如果依赖为空，则抛出异常
         * 
         * @memberof PluginMetadata
         */

    }, {
        key: 'markFailed',
        value: function markFailed() {
            if (this.dependencyConstraints.length === 0) {
                throw new Error('The plugin ' + this.id + ' with empty dependencies is always resolved successfully.');
            }
            this.state = _ResolveState2.default.RESOLVEFAILED;
            this.dependencies = [];
        }

        /**
         * 标记为成功解析
         * 
         * @memberof PluginMetadata
         */

    }, {
        key: 'markSuccess',
        value: function markSuccess() {
            this.state = _ResolveState2.default.RESOLVESUCCESS;
        }
    }]);
    return PluginMetadata;
}();

exports.default = PluginMetadata;
//# sourceMappingURL=PluginMetadata.js.map